import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/forms/templates/$templateId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/template-engine/templates/$templateId',
      params: { templateId: params.templateId },
      replace: true,
    });
  },
});
